export const FEATURE_FLAG_NAMES = [
  'KnowledgeManagement',
  'Integrations',
  'ProjectVersioning',
  'OneBlueprint',
  'KnowledgeManagementPatternQuantities',
  'HierarchyTreeV2',
  'ProjectGraph',
  'ProjectGrid',
  'ProjectAudit'
] as const;

export type FeatureFlagNames = (typeof FEATURE_FLAG_NAMES)[number];

export const featureFlagNamesSet = new Set<string>(FEATURE_FLAG_NAMES);
